import * as React from "react";
import { memo } from "react";
const SvgTriangle = (props) => /* @__PURE__ */ React.createElement("svg", { width: 15, height: 79, viewBox: "0 0 15 79", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 0L15 37.969L0 79V0Z", fill: "#BDD3E5" }));
const Memo = memo(SvgTriangle);
export default Memo;
